/* global axios */
import ApiClient from './ApiClient';

class TalkviaCreditEnginesAPI extends ApiClient {
  constructor() {
    super('talkvia_credit_engines', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  banks(params = {}) {
    return axios.get(`${this.url}/banks`, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_credit_engine: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_credit_engine: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TalkviaCreditEnginesAPI();
